<ng-container *ngIf="isCreateReportMode$ | async">
  <ng-container
    *ngIf="!(selectedFields$ | async).has(field.bindId); else ButtonCompleteRef"
    [ngTemplateOutlet]="ButtonRef"
    [ngTemplateOutletContext]="{ 
      icon: 'add', 
      extraIconClass: '', 
      click: onAddField, 
      title: ButtonConstants.Icon.addTitle 
    }"
  >
  </ng-container>
</ng-container>

<ng-template #ButtonCompleteRef>
  <ng-container
    [ngTemplateOutlet]="ButtonRef"
    [ngTemplateOutletContext]="{ 
      icon: 'confirm-filled', 
      extraIconClass: 'icon-success', 
      click: onRemoveField, 
      title: ButtonConstants.Icon.addedTitle 
    }"
  >
  </ng-container>
</ng-template>

<ng-template #ButtonRef let-icon="icon" let-extraIconClass="extraIconClass" let-click="click" let-title="title">
  <button
    [attr.data-automation-id]="ButtonConstants.Icon.automationId + '_' + icon"
    title="{{ title | translate }}"
    soho-button="icon"
    [icon]="icon"
    [extraIconClass]="extraIconClass"
    (click)="click()"
  ></button>
</ng-template>
